export const getAuthentication = store => store.authentication;
export const getDecodedToken = store => getAuthentication(store).decodedToken;
export const getPermissions = store =>
    (getDecodedToken(store) || {}).permissions || [];
